import script from "./WeChatSearchWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatSearchWindow.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatSearchWindow.vue?vue&type=style&index=0&id=3b937716&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b937716"]])

export default __exports__